import { auth } from "@/features/auth/providers/firebase"
import { useQuizStore } from "@/stores/quiz-store"
import { getAppleToken } from "@/shared/lib/apple-identity"
import { buildUserProfile } from "./domain/quiz-profile"
import { userService } from "./api/user-service"

/**
 * Create/refresh the signed-in user's profile on the backend from the quiz
 * answers. Idempotent (backend upserts), safe to call on every sign-in.
 * No-ops when the backend isn't configured, there's no auth user, or the quiz
 * answers don't form a valid profile.
 */
export async function syncUserProfileFromQuiz(): Promise<void> {
  if (!userService.isConfigured) return

  const current = auth.currentUser

  if (!current) return

  // Fall back to the provider display name (Apple/Google) when the funnel never
  // asked for a name (astro-map / soulmate), so those users are still created.
  const profile = buildUserProfile(useQuizStore.getState().answers, {
    fallbackName: current.displayName,
  })

  if (!profile) return

  // Apple sign-in: persist the Apple token so the credits webhook can resolve
  // this user by it. doc-id stays firebaseId.
  const appleToken = getAppleToken(current)

  const token = await current.getIdToken()
  await userService.upsertMe(token, { ...profile, ...(appleToken ? { appleToken } : {}) })
}
